import React from "react";
import { Select as SelectMui, MenuItem, FormControl, InputLabel, FormHelperText, useTheme } from "@mui/material";

const SelectFormInput = ({ id, label, options, formik }) => {
    const theme = useTheme();
    const labelId = `label-select-${id}`;

    return (
        <FormControl variant="outlined" fullWidth>
            <InputLabel size="small" id={labelId}>{label}</InputLabel>
            <SelectMui
                id={id}
                name={id}
                value={Boolean(formik) ? (formik.values[id] ?? "") : ""}
                onChange={(event, child) => {
                    return Boolean(formik) ? formik.handleChange(event, child) : null;
                }}
                onBlur={Boolean(formik) ? formik.handleBlur : null}
                labelId={labelId}
                label={label}
                size="small"
                error={Boolean(formik) ? (formik.touched[id] && Boolean(formik.errors[id])) : false}
            >
                {
                    options.map((item) => {
                        return <MenuItem key={`opt-${item.id}`} value={item.id}>{item.label}</MenuItem>
                    })
                }
            </SelectMui>
            <FormHelperText>
                {Boolean(formik) && formik.touched[id] && formik.errors[id] ? formik.errors[id] : ""}
            </FormHelperText>
        </FormControl>
    );
}

export default SelectFormInput;
